var parent = require('../../stable/object/define-property');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/object/define-property.js
// module id = 4321
// module chunks = 25